export default [
    {
        type: "uni",
        id: 1,
        title:
            "Bitte geben Sie an, wie sehr Sie den folgenden Aussagen zustimmen",
        items: [
            {
                id: 1,
                text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
            },
            {
                id: 2,
                text: "Der Dozent/Die Dozentin hat die Inhalte angemessen präsentiert und wiederholt.",
            },
            {
                id: 3,
                text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
            },
            {
                id: 4,
                text: "Der Dozent/die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
            },
            {
                id: 5,
                text: "Der Dozent/Die Dozentin gab die Möglichkeit Fragen zu stellen.",
            },
            {
                id: 6,
                text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
            },
            {
                id: 7,
                text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
            },
            {
                id: 8,
                text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
            },
            {
                id: 9,
                text: "Der Dozent/Die Dozentin hat die Inhalte interessant vermittelt.",
            },
            {
                id: 10,
                text: "Das von dem Dozenten/der Dozentin zur Verfügung gestellte Material bzw. die von ihm/ihr eingesetzten Medien waren hilfreich.",
            },
            {
                id: 11,
                text: "Das Betreuungsangebot des Dozenten/der Dozentin (z.B. im Rahmen von Sprechstunden) war ausreichend.",
            },
            {
                id: 12,
                text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
            },
            {
                id: 13,
                text: "Die Veranstaltung war übersichtlich und verständlich.",
            },
            {
                id: 14,
                text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
            },
            {
                id: 15,
                text: "Ich habe in der Veranstaltung Wichtiges gelernt.",
            },
            {
                id: 16,
                text: "Ich habe in der Veranstaltung wichtige Kompetenzen weiterentwickelt.",
            },
            {
                id: 17,
                text: "Die vermittelten Kompetenzen sind für meine persönliche Entwicklung relevant.",
            },
            {
                id: 18,
                text: "Die Veranstaltung hilft mir dabei, mich auf das Arbeitsleben vorzubereiten.",
            },
            {
                id: 19,
                text: "Die Veranstaltung macht es einfacher, nach dem Studium einen guten Beruf zu finden.",
            },
            {
                id: 20,
                text: "Mit den anderen Studierenden Ideen auszutauschen ist hilfreich, um meine Ziele zu errreichen.",
            },
            {
                id: 21,
                text: "Die Veranstaltung regt mich dazu an, über meinen zukünfitgen Beruf nachzudenken.",
            },
            {
                id: 22,
                text: "Die Veranstaltung gibt mir Selbstvertrauen und Inspiration für meine Zukunft.",
            },
            {
                id: 23,
                text: "Insgesamt fand ich die Veranstaltung gut.",
            },
            {
                id: 24,
                text: "In der Veranstaltung habe ich viel gelernt.",
            },
            {
                id: 25,
                text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
            },
            {
                id: 26,
                text: "Ich würde die Veranstaltung weiterempfehlen.",
            },
        ],
    },
    {
        type: "text",
        id: 2,
        items: [
            {
                id: 27,
                text: "Sonstige Anmerkungen zu der Veranstaltung (Lob/Kritik)",
            },
        ],
    },
];